import React, { useEffect, useRef, useState } from "react";
import { Bell } from "lucide-react";
import { useNotifications } from "../../context/NotificationsContext";
import NotificationDropdown from "./NotificationDropdown";

const NotificationBell = () => {
  const [open, setOpen] = useState(false);
  const buttonRef = useRef(null);
  const { unreadCount } = useNotifications();

  useEffect(() => {
    if (!open) return;
    const onKey = (e) => {
      if (e.key === "Escape") setOpen(false);
    };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open]);

  const badgeLabel = unreadCount > 9 ? "9+" : String(unreadCount);

  return (
    <div className="relative">
      <button
        ref={buttonRef}
        type="button"
        onClick={() => setOpen((o) => !o)}
        aria-label={
          unreadCount > 0
            ? `Notifications, ${unreadCount} unread`
            : "Notifications"
        }
        aria-haspopup="dialog"
        aria-expanded={open}
        className={`relative inline-flex items-center justify-center w-11 h-11 rounded-full border border-[#E5E7EB] transition-colors ${open ? "bg-[#EAF6FF]" : "bg-white hover:bg-[#F7F9FC]"
          }`}
      >
        <Bell size={20} className="text-[#1F2937]" strokeWidth={1.8} />
        {unreadCount > 0 && (
          <span
            className="absolute -top-1 -right-1 min-w-[20px] h-[20px] px-[5px] rounded-full bg-[#EF4444] text-white text-[11px] font-bold flex items-center justify-center border-2 border-white"
            style={{ lineHeight: 1 }}
            aria-hidden="true"
          >
            {badgeLabel}
          </span>
        )}
      </button>

      {open && (
        <NotificationDropdown
          onClose={() => setOpen(false)}
          anchorRef={buttonRef}
        />
      )}
    </div>
  );
};

export default NotificationBell;
